module.exports = __webpack_public_path__ + "img/universite-logo-default.fa2f579c.jpg";